import React from 'react';

const Card = ({ children, className = '' }) => (
    <div className={`card ${className}`}>
      {children}
    </div>
  );
  
  const CardContent = ({ children, className = '' }) => (
    <div className={`card-content ${className}`}>
      {children}
    </div>
  );
  
  const StatCard = ({ title, value, icon: Icon }) => (
    <Card>
      <CardContent>
        <div className="stat-card">
          <div className="stat-icon">
            <Icon className="icon" />
          </div>
          <div className="stat-info">
            <p>{title}</p>
            <p>{value}</p>
          </div>
        </div>
      </CardContent>
    </Card>
  );

export { Card, CardContent, StatCard };